import { useNavigate } from 'react-router-dom';
import { Project } from '../Projects/projects';
import { useDispatch } from 'react-redux';
import { projectSlice } from '../../redux/ProjectSlice';
import { Box, Card, IconButton, Stack, Typography } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { createProjectFromExample } from '../../utils/helpers';
import theme from '../../theme/theme';

interface ExampleCardProps {
  example: Project;
}

const ExampleCard = ({ example }: ExampleCardProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCardClick = () => {
    const newProject = createProjectFromExample(example);
    dispatch(projectSlice.actions.onCreateProject(newProject));
    dispatch(projectSlice.actions.onAddProject(newProject));
    dispatch(projectSlice.actions.onUpdateLastModified(new Date().toISOString()));
    window.projectId = newProject.id;
    navigate(`/editor/${newProject.id}`);
  };

  return (
    <Card sx={{ width: 250, height: 250, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Stack spacing={0}>
        <Stack
          onClick={handleCardClick}
          justifyContent="center"
          alignItems="center"
          spacing={1}
          sx={{ cursor: 'pointer', width: '100%', height: '100%' }}
        >
          <Box display="flex" bgcolor="text.primary" height={'100%'} width={'100%'} justifyContent="center" alignItems="center">
            <SmartToyIcon
              sx={{
                width: 150,
                height: 150,
                color: theme.vars?.palette?.robotIcon?.main || theme.palette.robotIcon.main,
              }}
            />
          </Box>
          <Typography>{example.name}</Typography>
        </Stack>
        <IconButton>
          <MoreHorizIcon />
        </IconButton>
      </Stack>
    </Card>
  );
};

export default ExampleCard;
